/* ═══════════════════════════════════════════════
   LOUBLU THEME v1.1 — loublu.js
   ═══════════════════════════════════════════════ */

/* ── CURRENCY SWITCHER (standalone) ── */
var _currencyRates = null;
var _activeCurrency = 'IDR';
var _currencySymbols = { IDR:'Rp ', USD:'$', EUR:'€', GBP:'£', SGD:'S$', MYR:'RM ', AUD:'A$', JPY:'¥', KRW:'₩' };
// Fallback rates in case API is down (approximate)
var _fallbackRates = { IDR:1, USD:0.000062, EUR:0.000057, GBP:0.000048, SGD:0.000083, MYR:0.000292, AUD:0.000096, JPY:0.0095, KRW:0.085 };

function _fetchRates(cb) {
  if (_currencyRates) { cb(_currencyRates); return; }
  fetch('https://api.frankfurter.app/latest?from=IDR&to=USD,EUR,GBP,SGD,MYR,AUD,JPY,KRW')
    .then(function(r) { return r.json(); })
    .then(function(data) {
      _currencyRates = data.rates || {};
      _currencyRates['IDR'] = 1;
      cb(_currencyRates);
    })
    .catch(function() {
      _currencyRates = _fallbackRates;
      cb(_currencyRates);
    });
}

function _formatFromCents(shopifyCents) {
  var idr = Math.round(shopifyCents / 100);
  var rates = _currencyRates || _fallbackRates;
  if (_activeCurrency === 'IDR') {
    return 'Rp ' + idr.toLocaleString('id-ID');
  }
  var rate = rates[_activeCurrency] || _fallbackRates[_activeCurrency] || 0.000062;
  var converted = idr * rate;
  var sym = _currencySymbols[_activeCurrency] || _activeCurrency + ' ';
  return sym + converted.toFixed(2);
}

function _convertPrices() {
  document.querySelectorAll('.store-row-wrap').forEach(function(wrap) {
    var cents = parseFloat(wrap.dataset.price);
    if (isNaN(cents)) return;
    var priceEl = wrap.querySelector('.store-row-price');
    if (priceEl) priceEl.textContent = _formatFromCents(cents);
  });
  var featAnchor = document.getElementById('store-featured');
  var featPrice = document.getElementById('feat-price');
  if (featAnchor && featPrice) {
    var cents = parseFloat(featAnchor.dataset.price);
    if (!isNaN(cents)) featPrice.textContent = _formatFromCents(cents);
  }
  var prodPrice = document.getElementById('prod-price');
  if (prodPrice && prodPrice.dataset.priceCents) {
    prodPrice.textContent = _formatFromCents(parseFloat(prodPrice.dataset.priceCents));
  }
  var stickyPrice = document.getElementById('sticky-atc-price');
  if (stickyPrice && window._loubluProduct) {
    stickyPrice.textContent = _formatFromCents(window._loubluProduct.price);
  }
}

function _setCurrencyUI(currency) {
  var btn = document.getElementById('nav-currency-btn');
  if (btn) btn.textContent = currency;
  document.querySelectorAll('#nav-currency-menu button').forEach(function(b) {
    b.classList.toggle('active', b.dataset.val === currency);
  });
}

function toggleCurrencyMenu(e) {
  e.stopPropagation();
  var menu = document.getElementById('nav-currency-menu');
  var btn  = document.getElementById('nav-currency-btn');
  var isOpen = menu.classList.contains('open');
  menu.classList.toggle('open', !isOpen);
  btn.setAttribute('aria-expanded', !isOpen ? 'true' : 'false');
}

function selectCurrency(currency) {
  _activeCurrency = currency;
  localStorage.setItem('loublu_currency', currency);
  _setCurrencyUI(currency);
  var menu = document.getElementById('nav-currency-menu');
  var btn  = document.getElementById('nav-currency-btn');
  if (menu) menu.classList.remove('open');
  if (btn)  btn.setAttribute('aria-expanded', 'false');
  if (currency === 'IDR') {
    _convertPrices();
  } else {
    _fetchRates(function() { _convertPrices(); });
  }
}

function switchCurrency(currency) { selectCurrency(currency); }

document.addEventListener('DOMContentLoaded', function() {
  var saved = localStorage.getItem('loublu_currency') || 'IDR';
  _activeCurrency = saved;
  _setCurrencyUI(saved);
  if (saved !== 'IDR') {
    _fetchRates(function() { _convertPrices(); });
  }
  document.addEventListener('click', function(e) {
    var wrap = document.getElementById('nav-currency-wrap');
    if (wrap && !wrap.contains(e.target)) {
      var menu = document.getElementById('nav-currency-menu');
      var btn  = document.getElementById('nav-currency-btn');
      if (menu) menu.classList.remove('open');
      if (btn)  btn.setAttribute('aria-expanded', 'false');
    }
  });
});

/* ── MENU ── */
function openMenu() {
  var menu = document.getElementById('menu');
  var dim = document.getElementById('menu-dim');
  var ham = document.getElementById('ham');
  menu.classList.add('open');
  dim.classList.add('open');
  ham.setAttribute('aria-expanded', 'true');
  dim.removeAttribute('aria-hidden');
  document.body.style.overflow = 'hidden';
}
function closeMenu() {
  var menu = document.getElementById('menu');
  var dim = document.getElementById('menu-dim');
  var ham = document.getElementById('ham');
  menu.classList.remove('open');
  dim.classList.remove('open');
  ham.setAttribute('aria-expanded', 'false');
  dim.setAttribute('aria-hidden', 'true');
  document.body.style.overflow = '';
}
(function() {
  var hamEl = document.getElementById('ham');
  var dimEl = document.getElementById('menu-dim');
  if (hamEl) hamEl.addEventListener('click', function() {
    var menu = document.getElementById('menu');
    if (menu) { menu.classList.contains('open') ? closeMenu() : openMenu(); }
  });
  if (dimEl) dimEl.addEventListener('click', closeMenu);
})();

/* ── MENU ACCORDION ── */
document.querySelectorAll('.menu-acc-trigger').forEach(function(t) {
  function toggle() {
    var body = t.nextElementSibling;
    var isOpen = body.classList.contains('open');
    document.querySelectorAll('.menu-acc-body').forEach(function(b){ b.classList.remove('open'); });
    document.querySelectorAll('.menu-acc-trigger').forEach(function(tt){
      tt.classList.remove('open');
      tt.setAttribute('aria-expanded', 'false');
    });
    if (!isOpen) {
      body.classList.add('open');
      t.classList.add('open');
      t.setAttribute('aria-expanded', 'true');
    }
  }
  t.addEventListener('click', toggle);
  t.addEventListener('keydown', function(e) {
    if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); }
  });
});

/* ── CART DRAWER ── */
/* ── CART CACHE ── */
var _cartCache = null;

function openCart(loading) {
  var drawer = document.getElementById('cart-drawer');
  var dim = document.getElementById('cart-dim');
  var ham = document.getElementById('ham');
  drawer.classList.add('open');
  dim.classList.add('open');
  dim.removeAttribute('aria-hidden');
  document.body.style.overflow = 'hidden';
  if (ham) ham.style.display = 'none';
  if (loading && !_cartCache) {
    // Show spinner immediately while API responds
    var items = document.getElementById('cart-items');
    if (items) items.innerHTML = '<div style="display:flex;align-items:center;justify-content:center;height:120px;opacity:.4;font-size:10px;letter-spacing:.2em;">LOADING...</div>';
  } else if (_cartCache) {
    renderCart(_cartCache);
  }
  if (!loading) fetchAndRenderCart();
}

function refreshCart() {
  fetchAndRenderCart();
}
function closeCart() {
  var drawer = document.getElementById('cart-drawer');
  var dim = document.getElementById('cart-dim');
  var ham = document.getElementById('ham');
  drawer.classList.remove('open');
  dim.classList.remove('open');
  dim.setAttribute('aria-hidden', 'true');
  document.body.style.overflow = '';
  if (ham) ham.style.display = '';
}
(function() { var el = document.getElementById('cart-dim'); if (el) el.addEventListener('click', closeCart); })();

/* Prefetch cart on hover so it's already cached when clicked */
var _cartBtn = document.querySelector('.nav-cart-btn');
if (_cartBtn) {
  _cartBtn.addEventListener('mouseenter', function() {
    if (!_cartCache) fetchAndRenderCart();
  }, { once: true });
}

/* ── CART API ── */
function fetchAndRenderCart() {
  fetch('/cart.js', { cache: 'no-store' })
    .then(function(r){ return r.json(); })
    .then(function(cart){ _cartCache = cart; renderCart(cart); });
}

function renderCart(cart) {
  // Update counts
  document.querySelectorAll('.cart-count').forEach(function(el){
    el.textContent = cart.item_count;
  });

  var items = document.getElementById('cart-items');
  var footer = document.getElementById('cart-footer');
  var freeBar = document.getElementById('free-shipping-bar');

  // Free shipping bar
  renderFreeShippingBar(cart);

  if (!cart.item_count) {
    items.innerHTML = '<div id="cart-empty"><span>YOUR CART IS EMPTY</span><a href="/collections/all">SHOP NOW</a></div>';
    footer.style.display = 'none';
    if (freeBar) freeBar.style.display = 'none';
    return;
  }

  footer.style.display = 'block';
  if (freeBar) freeBar.style.display = 'block';
  document.getElementById('cart-subtotal-amount').textContent = formatMoney(cart.total_price);

  items.innerHTML = cart.items.map(function(item) {
    var variantLine = item.variant_title && item.variant_title !== 'Default Title'
      ? '<div class="cart-item-variant">' + item.variant_title + '</div>'
      : '';
    var imgSrc = item.image || '';
    var imgTag = imgSrc
      ? '<img class="cart-item-img" src="' + imgSrc + '" alt="' + escHtml(item.product_title) + '" loading="lazy">'
      : '<div class="cart-item-img"></div>';
    return '<div class="cart-item">' +
      imgTag +
      '<div class="cart-item-details">' +
        '<div class="cart-item-name">' + escHtml(item.product_title) + '</div>' +
        variantLine +
        '<div class="cart-item-price">' + formatMoney(item.final_line_price) + '</div>' +
        '<div class="cart-item-actions">' +
          '<button class="cart-qty-btn" onclick="updateQty(\'' + item.key + '\',' + (item.quantity - 1) + ')" aria-label="Decrease quantity">−</button>' +
          '<span class="cart-qty" aria-label="Quantity: ' + item.quantity + '">' + item.quantity + '</span>' +
          '<button class="cart-qty-btn" onclick="updateQty(\'' + item.key + '\',' + (item.quantity + 1) + ')" aria-label="Increase quantity">+</button>' +
          '<button class="cart-remove" onclick="updateQty(\'' + item.key + '\',0)" aria-label="Remove ' + escHtml(item.product_title) + ' from cart">REMOVE</button>' +
        '</div>' +
      '</div>' +
    '</div>';
  }).join('');
}

function updateQty(key, qty) {
  // Optimistic update: reflect count change immediately
  if (_cartCache) {
    var diff = 0;
    for (var i = 0; i < _cartCache.items.length; i++) {
      if (_cartCache.items[i].key === key) {
        diff = qty - _cartCache.items[i].quantity;
        break;
      }
    }
    var newCount = Math.max(0, (_cartCache.item_count || 0) + diff);
    document.querySelectorAll('.cart-count').forEach(function(el){ el.textContent = newCount; });
  }
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: qty })
  })
  .then(function(r){ return r.json(); })
  .then(function(cart){ _cartCache = cart; renderCart(cart); });
}

/* ── FREE SHIPPING BAR (feature 5) ── */
function renderFreeShippingBar(cart) {
  var bar = document.getElementById('free-shipping-bar');
  var msg = document.getElementById('free-shipping-msg');
  var fill = document.getElementById('free-shipping-fill');
  if (!bar || !msg || !fill) return;

  // threshold in cents (settings value is in IDR, Shopify stores prices in cents)
  var thresholdIDR = window._loubluFreeShippingThreshold || 500000;
  var thresholdCents = thresholdIDR * 100;
  var total = cart.total_price || 0;
  var pct = Math.min(100, Math.round((total / thresholdCents) * 100));
  var remaining = thresholdCents - total;

  fill.style.width = pct + '%';

  if (total >= thresholdCents) {
    msg.textContent = 'You have unlocked free shipping!';
    msg.classList.add('unlocked');
  } else {
    msg.textContent = formatMoney(remaining) + ' away from free shipping';
    msg.classList.remove('unlocked');
  }
}

/* ── FORMAT MONEY ── */
function formatMoney(cents) {
  var rp = Math.round(cents / 100);
  return 'Rp ' + rp.toLocaleString('id-ID');
}

/* ── ESC HTML ── */
function escHtml(str) {
  return String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

/* ── ADD TO CART (product page) ── */
var selectedVariantId = null;
var selectedSizeLabel  = null;
var selectedColor      = null;
var selectedQuantity   = 1;

/* Resolve the correct variant from current color + size selection */
function resolveVariant() {
  var variants = window.__productVariants;
  if (!variants) return;

  var colorBtn = document.querySelector('.color-swatch.active');
  var sizeBtn  = document.querySelector('#prod-sizes .size-btn.active');
  selectedColor = colorBtn ? colorBtn.dataset.color : null;
  var size      = sizeBtn  ? sizeBtn.dataset.size   : null;

  if (!size) return; // size not yet selected — wait

  var match = null;
  for (var i = 0; i < variants.length; i++) {
    var v = variants[i];
    var colorPos = colorBtn ? parseInt(colorBtn.dataset.colorPosition) : 0;
    var sizePos  = sizeBtn  ? (colorPos === 1 ? 2 : 1) : 1;

    var vColor = colorPos === 1 ? v.option1 : v.option2;
    var vSize  = sizePos  === 1 ? v.option1 : v.option2;

    if (selectedColor) {
      if (vColor === selectedColor && vSize === size) { match = v; break; }
    } else {
      if (vSize === size) { match = v; break; }
    }
  }

  if (match) {
    selectedVariantId = String(match.id);
    var atcBtn = document.getElementById('add-to-cart-btn');
    if (atcBtn) { atcBtn.disabled = false; atcBtn.textContent = 'ADD TO CART'; }
    updateStickyAtc();
    showQtyStepper();
  }
}

/* ── QUANTITY STEPPER (product page) ── */
function _currentVariantMaxQty() {
  var variants = window.__productVariants;
  if (!variants || !selectedVariantId) return null;
  var v = variants.find(function(vv){ return String(vv.id) === String(selectedVariantId); });
  return (v && typeof v.inventory_quantity === 'number') ? v.inventory_quantity : null;
}

function _updateQtyBtnStates() {
  var wrap = document.getElementById('prod-qty');
  if (!wrap) return;
  var max = _currentVariantMaxQty();
  var btns = wrap.querySelectorAll('.qty-btn');
  var minusBtn = btns[0];
  var plusBtn  = btns[1];
  if (minusBtn) minusBtn.disabled = selectedQuantity <= 1;
  if (plusBtn)  plusBtn.disabled  = !!(max && selectedQuantity >= max);
}

function showQtyStepper() {
  var wrap = document.getElementById('prod-qty-wrap');
  if (!wrap) return;
  selectedQuantity = 1;
  var valEl = document.getElementById('prod-qty-value');
  if (valEl) valEl.textContent = '1';
  wrap.style.display = 'flex';
  _updateQtyBtnStates();
}

function changeQty(delta) {
  var valEl = document.getElementById('prod-qty-value');
  if (!valEl) return;
  var max = _currentVariantMaxQty();
  var next = selectedQuantity + delta;
  if (next < 1) next = 1;
  if (max && next > max) next = max;
  selectedQuantity = next;
  valEl.textContent = selectedQuantity;
  _updateQtyBtnStates();
}

/* ── VARIANT IMAGE GALLERY FILTER ── */
function _buildColorImageMap() {
  var variants = window.__productVariants || [];
  var btn = document.querySelector('.color-swatch');
  var colorPos = btn ? parseInt(btn.dataset.colorPosition, 10) : 1;
  var map = {};
  variants.forEach(function(v) {
    var color = colorPos === 1 ? v.option1 : v.option2;
    if (!color) return;
    if (!map[color]) map[color] = [];
    if (v.featured_image && v.featured_image.id) {
      if (map[color].indexOf(v.featured_image.id) === -1) {
        map[color].push(v.featured_image.id);
      }
    }
  });
  return map;
}

function filterGalleryByColor(color) {
  var validColors = ['white', 'black', 'khaki', 'charcoal', 'light grey', 'grey'];
  var divs = document.querySelectorAll('.prod-gallery-img');
  var lowerColor = color ? color.toLowerCase().trim() : null;
  divs.forEach(function(d) {
    var imgColor = (d.dataset.color || '').toLowerCase().trim();
    // Extract base color — handles "khaki main", "white main" etc.
    var imgBaseColor = imgColor.split(' ')[0];
    var isColorTag = validColors.indexOf(imgColor) !== -1 || validColors.indexOf(imgBaseColor) !== -1;
    if (!lowerColor || !isColorTag || imgColor === lowerColor || imgBaseColor === lowerColor) {
      d.style.display = '';
    } else {
      d.style.display = 'none';
    }
  });
}

/* Color swatch click */
function selectColor(btn) {
  document.querySelectorAll('.color-swatch').forEach(function(b){ b.classList.remove('active'); });
  btn.classList.add('active');
  selectedColor = btn.dataset.color;
  syncSizeButtons();

  // Keep URL in sync so sharing/back-nav lands on the right colorway
  try {
    var u = new URL(window.location.href);
    u.searchParams.set('color', selectedColor);
    history.replaceState(null, '', u.toString());
  } catch(e) {}

  // Update #prod-sub label
  var subEl = document.getElementById('prod-sub');
  if (subEl) subEl.textContent = selectedColor.toUpperCase();

  filterGalleryByColor(selectedColor);
  resolveVariant();
}

/* Wishlist toggle on product page */
function _wishlistKey(id) { return 'lb_saved_' + id; }

function initWishlistBtn(btn, productId) {
  if (!btn || !productId) return;
  var isSaved = !!localStorage.getItem(_wishlistKey(productId));
  btn.setAttribute('data-saved', isSaved ? '1' : '0');
  btn.innerHTML = isSaved ? '&#9829; SAVED' : '&#9825; SAVE';
}

function toggleWishlistBtn(btn, productId) {
  if (!btn) return;
  var saved = btn.getAttribute('data-saved') === '1';
  var newState = !saved;
  btn.setAttribute('data-saved', newState ? '1' : '0');
  btn.innerHTML = newState ? '&#9829; SAVED' : '&#9825; SAVE';
  try {
    if (newState && window._loubluProduct) {
      var p = window._loubluProduct;
      localStorage.setItem(_wishlistKey(productId), JSON.stringify({
        id: p.id, title: p.title, priceFmt: p.priceFmt, url: p.url, image: p.image
      }));
    } else {
      localStorage.removeItem(_wishlistKey(productId));
    }
  } catch(e) {}
}

function selectSize(btn) {
  document.querySelectorAll('#prod-sizes .size-btn').forEach(function(b){ b.classList.remove('active'); });
  btn.classList.add('active');
  selectedSizeLabel = btn.dataset.size || btn.textContent.trim();

  // If there are color swatches use resolveVariant, otherwise use the direct id
  if (window.__productVariants && document.querySelector('.color-swatch')) {
    resolveVariant();
  } else {
    selectedVariantId = btn.dataset.variantId;
    var atcBtn = document.getElementById('add-to-cart-btn');
    if (atcBtn) { atcBtn.disabled = false; atcBtn.textContent = 'ADD TO CART'; }
    updateStickyAtc();
    showQtyStepper();
  }
}

function addToCart(variantId) {
  var vid = variantId || selectedVariantId;
  if (!vid) return;

  var btn = document.getElementById('add-to-cart-btn');
  var stickyBtn = document.getElementById('sticky-atc-btn');

  if (btn) { btn.classList.add('loading'); btn.textContent = 'ADDING...'; }
  if (stickyBtn) { stickyBtn.textContent = 'ADDING...'; }

  // Open cart immediately with loading state — feels instant
  openCart(true);

  var qtyToAdd = selectedQuantity || 1;

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: vid, quantity: qtyToAdd })
  })
  .then(function(r){ return r.json(); })
  .then(function() {
    if (btn) {
      btn.classList.remove('loading');
      btn.textContent = 'ADDED ✓';
      setTimeout(function(){ btn.textContent = 'ADD TO CART'; }, 2000);
    }
    if (stickyBtn) {
      stickyBtn.textContent = 'ADDED ✓';
      setTimeout(function(){ stickyBtn.textContent = 'ADD TO CART'; }, 2000);
    }
    // Reset quantity back to 1 after a successful add
    selectedQuantity = 1;
    var qtyValEl = document.getElementById('prod-qty-value');
    if (qtyValEl) qtyValEl.textContent = '1';
    _updateQtyBtnStates();
    // Refresh cart contents now that API responded
    refreshCart();
  })
  .catch(function() {
    if (btn) { btn.classList.remove('loading'); btn.textContent = 'ADD TO CART'; }
    if (stickyBtn) { stickyBtn.textContent = 'ADD TO CART'; }
    closeCart();
  });
}

/* ── PRODUCT PAGE ACCORDION (feature 6) ── */
function toggleProdAcc(trigger) {
  var body = trigger.nextElementSibling;
  var isOpen = body && body.classList.contains('open');
  // Close all
  document.querySelectorAll('.prod-acc-trigger').forEach(function(t) {
    t.classList.remove('open');
    t.setAttribute('aria-expanded', 'false');
    if (t.nextElementSibling) t.nextElementSibling.classList.remove('open');
  });
  if (!isOpen) {
    trigger.classList.add('open');
    trigger.setAttribute('aria-expanded', 'true');
    if (body) body.classList.add('open');
  }
}
// Keyboard support for prod accordion
document.addEventListener('keydown', function(e) {
  if ((e.key === 'Enter' || e.key === ' ') && e.target.classList.contains('prod-acc-trigger')) {
    e.preventDefault();
    toggleProdAcc(e.target);
  }
});

/* ── SIZE GUIDE MODAL (with metafield support, feature 11) ── */
function openSizeGuide(handle) {
  var modal = document.getElementById('size-modal');
  if (!modal) return;

  // Auto-switch to the right tab based on product handle
  if (handle) {
    var h = handle.toLowerCase();
    var tabId = null;
    if (h.indexOf('tank') !== -1)    tabId = 'tank-top';
    else if (h.indexOf('barrel') !== -1)  tabId = 'barrel-jeans';
    else if (h.indexOf('relaxed') !== -1) tabId = 'relaxed-jeans';
    else if (h.indexOf('crest') !== -1)   tabId = 'crest-jacket';
    else if (h.indexOf('straight') !== -1) tabId = 'straight-leg-jeans';
    if (tabId) {
      var tabBtn = document.querySelector('.sg-tab[onclick*="' + tabId + '"]');
      if (tabBtn) switchSgTab(tabBtn, tabId);
    }
  }

  // If metafield content present, inject it
  if (window._loubluSizeGuideContent) {
    var contentEl = document.getElementById('size-modal-content');
    if (contentEl) contentEl.innerHTML = window._loubluSizeGuideContent;
  }
  modal.classList.add('open');
  modal.removeAttribute('aria-hidden');
}
function closeSizeGuide() {
  var modal = document.getElementById('size-modal');
  if (!modal) return;
  modal.classList.remove('open');
  modal.setAttribute('aria-hidden', 'true');
}
function switchSgTab(btn, panelId) {
  document.querySelectorAll('.sg-tab').forEach(function(t) { t.classList.remove('active'); });
  document.querySelectorAll('.sg-panel').forEach(function(p) { p.classList.remove('active'); });
  btn.classList.add('active');
  var panel = document.getElementById('sg-' + panelId);
  if (panel) panel.classList.add('active');
}
// Close modal on Escape
document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape') {
    closeSizeGuide();
    closeMenu();
    closeCart();
  }
});

/* ── THUMBNAIL SWAP (product page) ── */
function setMainImage(thumb) {
  var main = document.querySelector('#prod-main-img-wrap img');
  if (main) {
    main.src = thumb.src
      .replace(/_\d+x\d*\./, '_1200x.')
      .replace(/_\d+x\./, '_1200x.');
  }
  document.querySelectorAll('.prod-thumb').forEach(function(t){ t.classList.remove('active'); });
  thumb.classList.add('active');
}

/* ── STICKY MOBILE ATC (feature 4) ── */
function updateStickyAtc() {
  var nameEl = document.getElementById('sticky-atc-name');
  var sizeEl = document.getElementById('sticky-atc-size');
  var priceEl = document.getElementById('sticky-atc-price');

  if (!nameEl) return;

  var prod = window._loubluProduct;
  if (!prod) return;

  if (nameEl) nameEl.textContent = prod.title;
  if (sizeEl) sizeEl.textContent = selectedSizeLabel ? 'Size: ' + selectedSizeLabel : '';
  if (priceEl) priceEl.textContent = formatMoney(prod.price);
}

function initStickyAtc() {
  var atcBtn = document.getElementById('add-to-cart-btn');
  var stickyBar = document.getElementById('sticky-atc');
  if (!atcBtn || !stickyBar) return;

  // Only on mobile (<=768)
  var mq = window.matchMedia('(max-width: 768px)');
  if (!mq.matches) return;

  updateStickyAtc();

  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (!entry.isIntersecting) {
        stickyBar.classList.add('visible');
        stickyBar.setAttribute('aria-hidden', 'false');
      } else {
        stickyBar.classList.remove('visible');
        stickyBar.setAttribute('aria-hidden', 'true');
      }
    });
  }, { threshold: 0 });

  observer.observe(atcBtn);
}

/* ── FEATURED HOVER (collection page) ── */
function setFeat(row) {
  var img = document.getElementById('feat-img');
  var name = document.getElementById('feat-name');
  var sub = document.getElementById('feat-sub');
  var price = document.getElementById('feat-price');
  var cta = document.getElementById('feat-cta');
  var featLink = document.getElementById('store-featured');
  if (!img) return;
  if (row.dataset.img) {
    img.src = row.dataset.img;
    img.style.opacity = '1';
  }
  if (name) name.textContent = row.dataset.name || '';
  if (sub) sub.textContent = row.dataset.sub || '';
  if (price) price.innerHTML = row.dataset.priceFmt || row.dataset.price || '';
  if (cta) { cta.href = row.dataset.url || '#'; cta.style.display = ''; }
  if (featLink && row.dataset.url) featLink.href = row.dataset.url;
}

/* ── COLLECTION SORT + FILTER (feature 3) ── */
var _currentSortOrder = 'newest';
var _currentSizeFilter = 'all';
var _currentCategoryFilter = 'all';

function filterSize(btn) {
  _currentSizeFilter = btn.dataset.size;
  document.querySelectorAll('.size-filter-btn').forEach(function(b){
    b.classList.remove('active');
    b.setAttribute('aria-pressed', 'false');
  });
  btn.classList.add('active');
  btn.setAttribute('aria-pressed', 'true');
  applyCollectionFilters();
}

function filterCategory(btn) {
  _currentCategoryFilter = btn.dataset.category;
  document.querySelectorAll('.category-filter-btn').forEach(function(b){
    b.classList.remove('active');
    b.setAttribute('aria-pressed', 'false');
  });
  btn.classList.add('active');
  btn.setAttribute('aria-pressed', 'true');
  applyCollectionFilters();
}

function sortProducts(order) {
  _currentSortOrder = order;
  applyCollectionFilters();
}

function _rowMatchesFilters(row) {
  if (_currentSizeFilter !== 'all') {
    var sizes = (row.dataset.sizes || '').split(',');
    if (sizes.indexOf(_currentSizeFilter) === -1) return false;
  }
  if (_currentCategoryFilter !== 'all' && row.dataset.category !== _currentCategoryFilter) return false;
  return true;
}

function applyCollectionFilters() {
  var rows = Array.from(document.querySelectorAll('.store-row-wrap'));
  if (!rows.length) return;

  // Filter
  var visible = rows.filter(_rowMatchesFilters);
  var hidden = rows.filter(function(row) { return !_rowMatchesFilters(row); });

  // Sort visible
  visible.sort(function(a, b) {
    if (_currentSortOrder === 'price-asc') {
      return parseInt(a.dataset.price) - parseInt(b.dataset.price);
    } else if (_currentSortOrder === 'price-desc') {
      return parseInt(b.dataset.price) - parseInt(a.dataset.price);
    } else {
      // newest: sort by created desc
      return parseInt(b.dataset.created || 0) - parseInt(a.dataset.created || 0);
    }
  });

  // Always pin NEW items to top regardless of sort
  var newRows  = visible.filter(function(r) { return r.dataset.new === '1'; });
  var restRows = visible.filter(function(r) { return r.dataset.new !== '1'; });
  visible = newRows.concat(restRows);

  // Reorder DOM
  var body = document.getElementById('store-list-body');
  if (!body) return;
  visible.forEach(function(row) {
    row.style.display = '';
    body.appendChild(row);
  });
  hidden.forEach(function(row) {
    row.style.display = 'none';
  });

  // Update count
  var countEl = document.getElementById('store-product-count');
  if (countEl) countEl.textContent = visible.length + ' PRODUCTS';

  // Reset hero to default after DOM reorder
  (function(){
    var sf = document.getElementById('store-featured');
    var fi = document.getElementById('feat-img');
    var fn = document.getElementById('feat-name');
    var fs = document.getElementById('feat-sub');
    var fp = document.getElementById('feat-price');
    if (sf && fi && fi.tagName === 'IMG' && sf.dataset.img) fi.src = sf.dataset.img;
    if (fn) fn.textContent = sf ? (sf.dataset.name || '') : '';
    if (fs) fs.textContent = sf ? (sf.dataset.sub || '') : '';
    if (fp) fp.innerHTML = sf ? (sf.dataset.priceFmt || '') : '';
  })();

}

/* ── MOBILE HERO CAROUSEL ── */
function buildMobileCarousel() {
  if (window.innerWidth > 768) return;
  var featured = document.getElementById('store-featured');
  if (!featured) return;
  var rows = document.querySelectorAll('.store-row-wrap');
  if (!rows.length) return;

  var track = document.createElement('div');
  track.id = 'mobile-feat-track';

  rows.forEach(function(row) {
    var slide = document.createElement('a');
    slide.className = 'mobile-feat-slide';
    slide.href = row.dataset.url || '#';

    if (row.dataset.img) {
      var img = document.createElement('img');
      img.src = row.dataset.img;
      img.alt = row.dataset.name || '';
      slide.appendChild(img);
    }

    var overlay = document.createElement('div');
    overlay.className = 'mobile-feat-overlay';
    slide.appendChild(overlay);

    var info = document.createElement('div');
    info.className = 'mobile-feat-info';
    info.innerHTML =
      '<div class="mfi-name">' + (row.dataset.name || '') + '</div>' +
      '<div class="mfi-sub">' + (row.dataset.sub || '') + '</div>' +
      '<div class="mfi-price">' + (row.dataset.priceFmt || '') + '</div>' +
      '<span class="mfi-cta">VIEW PRODUCT →</span>';
    slide.appendChild(info);
    track.appendChild(slide);
  });

  var dots = document.createElement('div');
  dots.id = 'mobile-feat-dots';
  rows.forEach(function(_, i) {
    var dot = document.createElement('span');
    dot.className = 'mfd' + (i === 0 ? ' active' : '');
    dots.appendChild(dot);
  });

  track.addEventListener('scroll', function() {
    var idx = Math.round(track.scrollLeft / track.offsetWidth);
    dots.querySelectorAll('.mfd').forEach(function(d, i) {
      d.classList.toggle('active', i === idx);
    });
  }, { passive: true });

  featured.innerHTML = '';
  featured.appendChild(track);
  featured.appendChild(dots);
}

/* Init on page load */
document.addEventListener('DOMContentLoaded', function() {
  // Populate live category counts (row-based, matches the "X PRODUCTS" count convention)
  (function() {
    var rows = document.querySelectorAll('.store-row-wrap');
    var counts = {};
    rows.forEach(function(r) {
      var c = r.dataset.category;
      if (!c) return;
      counts[c] = (counts[c] || 0) + 1;
    });
    document.querySelectorAll('.category-filter-btn[data-category]').forEach(function(btn) {
      var cat = btn.dataset.category;
      if (cat === 'all') return;
      var span = btn.querySelector('.cat-count');
      if (span) span.textContent = counts[cat] || 0;
    });
  })();
  // Pin NEW items on collection page
  if (document.querySelector('.store-row-wrap')) applyCollectionFilters();
  // Default the featured panel to the first product so it's never blank on initial load
  // (mouseleave no longer clears the image — it should keep showing the last-hovered product)
  var _firstStoreRow = document.querySelector('.store-row-wrap');
  if (_firstStoreRow) setFeat(_firstStoreRow);

  // Mobile hero carousel
  buildMobileCarousel();
  // Restore wishlist state on product page
  var saveBtn = document.getElementById('prod-save-btn');
  if (saveBtn && window._loubluProduct) {
    initWishlistBtn(saveBtn, String(window._loubluProduct.id));
  }
  // Auto-select colorway from URL param (e.g. ?color=Black)
  var urlColor = new URLSearchParams(window.location.search).get('color');
  if (urlColor) {
    var matchBtn = Array.from(document.querySelectorAll('.color-swatch')).find(function(b) {
      return b.dataset.color.toLowerCase() === urlColor.toLowerCase();
    });
    if (matchBtn) {
      matchBtn.click();
    } else {
      var defaultColorBtn = document.querySelector('.color-swatch.active');
      if (defaultColorBtn) filterGalleryByColor(defaultColorBtn.dataset.color);
    }
  } else {
    var defaultColorBtn = document.querySelector('.color-swatch.active');
    if (defaultColorBtn) filterGalleryByColor(defaultColorBtn.dataset.color);
  }
});

/* ── QUICK ADD on collection (feature 2) ── */

/* Opens the size picker, closes any other open ones */
function openQuickAdd(e, btn) {
  e.preventDefault();
  e.stopPropagation();
  var wrap = btn.closest('.quick-add-wrap');
  // Close all others first
  document.querySelectorAll('.quick-add-wrap.open').forEach(function(w) {
    if (w !== wrap) w.classList.remove('open');
  });
  wrap.classList.toggle('open');
}

/* Close quick-add pickers when clicking outside */
document.addEventListener('click', function(e) {
  if (!e.target.closest('.quick-add-wrap')) {
    document.querySelectorAll('.quick-add-wrap.open').forEach(function(w) {
      w.classList.remove('open');
    });
  }
});

function quickAdd(e, btn) {
  e.preventDefault();
  e.stopPropagation();

  var variantId = btn.dataset.variantId;
  if (!variantId) return;

  btn.classList.add('qa-adding');

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
  .then(function(r){ return r.json(); })
  .then(function() {
    btn.classList.remove('qa-adding');
    btn.classList.add('qa-done');
    btn.textContent = '✓';
    setTimeout(function(){
      btn.classList.remove('qa-done');
      btn.textContent = btn.dataset.size || btn.textContent;
      // Reset wrap back to trigger button
      var wrap = btn.closest('.quick-add-wrap');
      if (wrap) wrap.classList.remove('open');
    }, 1500);
    openCart();
  })
  .catch(function() {
    btn.classList.remove('qa-adding');
  });
}

/* ── PRODUCT RECOMMENDATIONS (feature 1) ── */
function loadRecommendations() {
  var el = document.getElementById('recommendations');
  if (!el) return;
  var productId = el.dataset.productId;
  if (!productId) return;

  fetch('/recommendations/products.json?product_id=' + productId + '&limit=4')
    .then(function(r){ return r.json(); })
    .then(function(data) {
      var products = (data && data.products) ? data.products : [];
      if (!products.length) {
        el.style.display = 'none';
        return;
      }
      var grid = document.getElementById('recommendations-grid');
      if (!grid) return;

      grid.innerHTML = products.map(function(p) {
        imgUrl=(p.featured_image&&p.featured_image.src)||(p.images&&p.images[0]&&p.images[0].src)||''
        var imgTag = imgUrl
          ? '<img src="' + imgUrl + '" alt="' + escHtml(p.title) + '" loading="lazy" width="400" height="400">'
          : '<div style="width:100%;height:100%;background:var(--border);"></div>';
        var price = formatMoney(p.variants[0].price);

        // Build size picker if product has multiple variants
        var hasSizes = p.variants.length > 1;
        var sizePicker = '';
        if (hasSizes) {
          sizePicker = '<div class="rec-size-picker" id="rec-sizes-' + p.id + '">' +
            p.variants.map(function(v) {
              var disabled = !v.available ? 'disabled' : '';
              return '<button class="rec-size-pill" data-variant-id="' + v.id + '" ' + disabled +
                ' onclick="recAddToCart(event, this, ' + p.id + ')" aria-label="Size ' + escHtml(v.title) + '">' +
                escHtml(v.title) + '</button>';
            }).join('') +
          '</div>';
        }

        var addBtnAttr = hasSizes
          ? 'onclick="toggleRecSizePicker(event, ' + p.id + ')"'
          : 'onclick="recAddToCart(event, this, ' + p.id + ')" data-variant-id="' + p.variants[0].id + '"';

        return '<div class="rec-card">' +
          '<a href="' + p.url + '" class="rec-card-img-wrap" tabindex="-1" aria-hidden="true">' +
            imgTag +
          '</a>' +
          '<a href="' + p.url + '" class="rec-card-name">' + escHtml(p.title) + '</a>' +
          '<div class="rec-card-price">' + price + '</div>' +
          '<div class="rec-quick-add-wrap">' +
            '<button class="rec-quick-add-btn" ' + addBtnAttr + ' aria-label="' + (hasSizes ? 'Select size for ' : 'Add to cart: ') + escHtml(p.title) + '">' +
              (hasSizes ? 'SELECT SIZE' : 'QUICK ADD') +
            '</button>' +
            sizePicker +
          '</div>' +
        '</div>';
      }).join('');
    })
    .catch(function() {
      var el2 = document.getElementById('recommendations');
      if (el2) el2.style.display = 'none';
    });
}

function toggleRecSizePicker(e, productId) {
  e.preventDefault();
  e.stopPropagation();
  var picker = document.getElementById('rec-sizes-' + productId);
  if (!picker) return;
  picker.classList.toggle('open');
}

function recAddToCart(e, btn, productId) {
  e.preventDefault();
  e.stopPropagation();
  var variantId = btn.dataset.variantId;
  if (!variantId) return;

  btn.disabled = true;
  var origText = btn.textContent;
  btn.textContent = '...';

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
  .then(function(r){ return r.json(); })
  .then(function() {
    btn.textContent = '✓';
    setTimeout(function(){
      btn.disabled = false;
      btn.textContent = origText;
      // Close size picker if open
      if (productId) {
        var picker = document.getElementById('rec-sizes-' + productId);
        if (picker) picker.classList.remove('open');
      }
    }, 1800);
    openCart();
  })
  .catch(function() {
    btn.disabled = false;
    btn.textContent = origText;
  });
}

/* ── INTRO CLICK ANYWHERE ── */
var introEl = document.getElementById('intro');
if (introEl) {
  introEl.style.cursor = 'pointer';
  introEl.addEventListener('click', function() {
    window.location.href = '/collections/all';
  });
}

/* ── TICKER ── */
function updateTicker() {
  var el = document.getElementById('intro-ticker');
  if (!el) return;
  el.textContent = 'FALL · WINTER 2026';
}
updateTicker();
setInterval(updateTicker, 60000);

/* ── PAGE TRANSITION ── */
document.addEventListener('click', function(e) {
  var link = e.target.closest('a');
  if (!link) return;
  var href = link.getAttribute('href');
  if (!href || href.startsWith('#') || href.startsWith('http') || link.target === '_blank') return;
  e.preventDefault();
  var cover = document.getElementById('page-cover');
  cover.classList.add('out');
  setTimeout(function(){ window.location.href = href; }, 350);
});

window.addEventListener('pageshow', function(e) {
  var cover = document.getElementById('page-cover');
  if (!cover) return;
  // Only flash black if navigating back (bfcache) or coming from an internal link transition
  if (e.persisted || cover.classList.contains('out')) {
    cover.style.opacity = '1';
    cover.classList.remove('out');
  }
  requestAnimationFrame(function(){
    requestAnimationFrame(function(){
      cover.style.transition = 'opacity .45s ease';
      cover.style.opacity = '0';
    });
  });
});

/* ── SEARCH ── */
function openSearch() {
  var overlay = document.getElementById('search-overlay');
  if (!overlay) return;
  overlay.classList.add('open');
  overlay.removeAttribute('aria-hidden');
  document.body.style.overflow = 'hidden';
  setTimeout(function(){ var inp = document.getElementById('search-input'); if (inp) inp.focus(); }, 120);
}
function closeSearch() {
  var overlay = document.getElementById('search-overlay');
  if (!overlay) return;
  overlay.classList.remove('open');
  overlay.setAttribute('aria-hidden', 'true');
  document.body.style.overflow = '';
  var inp = document.getElementById('search-input');
  if (inp) inp.value = '';
  var res = document.getElementById('search-results');
  if (res) res.innerHTML = '';
}
var _searchTimer = null;
function doSearch(q) {
  clearTimeout(_searchTimer);
  var res = document.getElementById('search-results');
  if (!q || q.length < 2) { if (res) res.innerHTML = ''; return; }
  _searchTimer = setTimeout(function() {
    fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8')
      .then(function(r){ return r.json(); })
      .then(function(data) {
        var products = (data.resources && data.resources.results && data.resources.results.products) || [];
        var html = '';
        if (products.length === 0) {
          html = '<div style="padding:20px 0;font-size:10px;letter-spacing:.1em;color:#666;text-align:center;">NO RESULTS FOUND</div>';
        } else {
          products.forEach(function(p) {
            var imgHtml = p.featured_image
              ? '<img src="' + p.featured_image + '" alt="' + p.title + '" loading="lazy" style="width:100%;height:100%;object-fit:cover;">'
              : '';
            var priceHtml = '';
            if (p.price_min != null) {
              priceHtml = 'Rp ' + Math.round(p.price_min).toLocaleString('id-ID');
            }
            html += '<a href="' + p.url + '" class="search-result-item" onclick="closeSearch()">';
            html += '<div class="search-result-img">' + imgHtml + '</div>';
            html += '<div class="search-result-info">';
            html += '<div class="search-result-name">' + p.title + '</div>';
            html += '<div class="search-result-price">' + priceHtml + '</div>';
            html += '</div></a>';
          });
        }
        if (res) res.innerHTML = html;
      })
      .catch(function() {
        if (res) res.innerHTML = '<div style="padding:20px 0;font-size:10px;letter-spacing:.1em;color:#666;text-align:center;">SEARCH UNAVAILABLE</div>';
      });
  }, 250);
}
/* Close search on Escape */
document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape') { closeSearch(); }
});
/* Close search on overlay background click */
var _searchOverlay = document.getElementById('search-overlay');
if (_searchOverlay) {
  _searchOverlay.addEventListener('click', function(e) {
    if (e.target === _searchOverlay) closeSearch();
  });
}

/* ── INIT ── */
fetchAndRenderCart();
loadRecommendations();
initStickyAtc();
document.addEventListener('DOMContentLoaded', function() {
  var atcBtn = document.getElementById('add-to-cart-btn');
  if (atcBtn && !atcBtn.disabled && document.getElementById('prod-qty-wrap')) {
    showQtyStepper();
  }
});


/* ═══════════════════════════════════════════════
   COMPLETE THE LOOK
   ═══════════════════════════════════════════════ */
(function initCTL() {
  if (!window._ctlData) return;
  var data = window._ctlData;

  // If no sizes on partner, lock in first available variant immediately
  var ctlSelectedVariantId = data.partnerHasSizes
    ? null
    : (data.partnerFirstAvailableVariantId ? String(data.partnerFirstAvailableVariantId) : null);

  function ctlFormatMoney(price) {
    // Shopify stores all prices in cents (divide by 100 for display)
    return 'Rp' + (price / 100).toLocaleString('id-ID');
  }

  function ctlUpdateTotal() {
    var totalEl = document.getElementById('ctl-total-price');
    var addBtn  = document.getElementById('ctl-add-btn');
    if (!totalEl) return;

    var mainVariantId = window.selectedVariantId;
    var hasMain    = !!mainVariantId || !data.mainHasVariants;
    var hasPartner = !!ctlSelectedVariantId;

    if (hasMain && hasPartner) {
      var partnerV = data.partnerVariants.find(function(v) {
        return String(v.id) === String(ctlSelectedVariantId);
      });
      var partnerPrice = partnerV ? partnerV.price : data.partnerPriceCents;

      var mainV = (window.__productVariants && mainVariantId)
        ? window.__productVariants.find(function(v) { return String(v.id) === String(mainVariantId); })
        : null;
      var mainPrice = mainV ? mainV.price : data.mainProductPrice;

      totalEl.textContent = ctlFormatMoney(mainPrice + partnerPrice);
      if (addBtn) addBtn.disabled = false;
    } else {
      totalEl.textContent = '—';
      if (addBtn) addBtn.disabled = true;
    }
  }

  window.ctlSelectSize = function(e, btn) {
    e.preventDefault();
    document.querySelectorAll('.ctl-size-btn').forEach(function(b) { b.classList.remove('active'); });
    btn.classList.add('active');
    ctlSelectedVariantId = btn.dataset.variantId;
    var msg = document.getElementById('ctl-msg');
    if (msg) { msg.textContent = ''; msg.className = ''; }
    ctlUpdateTotal();
  };

  window.ctlAddBoth = async function(e) {
    e.preventDefault();
    var btn = document.getElementById('ctl-add-btn');
    var msg = document.getElementById('ctl-msg');
    if (!btn) return;
    if (msg) { msg.textContent = ''; msg.className = ''; }

    // 1. Validate main size selected
    var mainVariantId = window.selectedVariantId;
    if (!mainVariantId && data.mainHasVariants) {
      if (msg) msg.textContent = 'Please select your size above first.';
      var sizesEl = document.getElementById('prod-sizes');
      if (sizesEl) sizesEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }

    // 2. Validate partner size selected
    if (!ctlSelectedVariantId && data.partnerHasSizes) {
      if (msg) msg.textContent = 'Please select a size for ' + data.partnerTitle + '.';
      return;
    }

    // 3. Live stock check
    var mainV = (window.__productVariants && mainVariantId)
      ? window.__productVariants.find(function(v) { return String(v.id) === String(mainVariantId); })
      : null;
    var partnerV = ctlSelectedVariantId
      ? data.partnerVariants.find(function(v) { return String(v.id) === String(ctlSelectedVariantId); })
      : null;

    if (mainV && !mainV.available) {
      if (msg) msg.textContent = 'Your selected size is sold out.';
      return;
    }
    if (partnerV && !partnerV.available) {
      if (msg) msg.textContent = data.partnerTitle + ' — this size is sold out.';
      return;
    }

    // 4. Add to cart
    var prevText = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'ADDING...';
    if (typeof openCart === 'function') openCart(true);

    var items = [];
    if (mainVariantId) items.push({ id: parseInt(mainVariantId, 10), quantity: 1 });
    if (ctlSelectedVariantId) items.push({ id: parseInt(ctlSelectedVariantId, 10), quantity: 1 });

    try {
      var res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      });
      if (!res.ok) {
        var errBody = await res.json().catch(function() { return {}; });
        throw new Error(errBody.description || 'Could not add to cart.');
      }
      if (typeof refreshCart === 'function') await refreshCart();

      btn.textContent = 'ADDED ✓';
      if (msg) { msg.textContent = 'Both items added to cart.'; msg.className = 'success'; }
      setTimeout(function() {
        btn.textContent = prevText;
        btn.disabled = false;
        if (msg) { msg.textContent = ''; msg.className = ''; }
      }, 2500);
    } catch (err) {
      btn.textContent = prevText;
      btn.disabled = false;
      if (msg) msg.textContent = err.message || 'Something went wrong — please try again.';
      // Close the optimistic cart open if add failed
      if (typeof openCart === 'function') openCart(false);
    }
  };

  // Hook into existing selectSize / selectColor to keep bundle total in sync
  var _origSelectSize = window.selectSize;
  if (typeof _origSelectSize === 'function') {
    window.selectSize = function(btn) {
      _origSelectSize(btn);
      setTimeout(ctlUpdateTotal, 60);
    };
  }

  var _origSelectColor = window.selectColor;
  if (typeof _origSelectColor === 'function') {
    window.selectColor = function(btn) {
      _origSelectColor(btn);
      setTimeout(ctlUpdateTotal, 60);
    };
  }

  // Initial render
  ctlUpdateTotal();
})();
function syncSizeButtons(){
  if(!selectedColor || !window.__productVariants) return;
  document.querySelectorAll('#prod-sizes .size-btn').forEach(function(btn){
    var size = btn.dataset.size;
    var variant = window.__productVariants.find(function(v){
      return v.option1 === selectedColor && v.option2 === size;
    });
    if(!variant) return;
    btn.dataset.variantId = variant.id;
    if(variant.available){
      btn.disabled = false;
      btn.classList.remove('sold-out');
      btn.setAttribute('aria-label','Size '+size);
    } else {
      btn.disabled = true;
      btn.classList.add('sold-out');
      btn.setAttribute('aria-label','Size '+size+' — sold out');
    }
  });
}
document.addEventListener('DOMContentLoaded', function(){
  var activeSwatch = document.querySelector('.color-swatch.active');
  if(activeSwatch){ selectedColor = activeSwatch.dataset.color; syncSizeButtons(); }
});

/* ── FAQ ACCORDION (static FAQ page) ── */
document.addEventListener('click', function(e) {
  var trigger = e.target.closest('.faq-trigger');
  if (!trigger) return;
  var body = trigger.nextElementSibling;
  var isOpen = trigger.classList.contains('open');
  if (isOpen) {
    trigger.classList.remove('open');
    if (body) body.classList.remove('open');
  } else {
    trigger.classList.add('open');
    if (body) body.classList.add('open');
  }
});
